/* Returns a page number for each member in the array */
export function getPagesFromArray(input = [], countPerPage = 3) {
  let payload = []; //Set up our array that will be returned. It starts empty.

  let page = 1; //start at page 1
  let countOfCurrentPage = 0; //tally 0 entries for first page

  //For each member of the array
  input.forEach(() => {
    payload.push(page); //add the current page for this member
    countOfCurrentPage++; //uptick how many entries are in this page

    //If we've now reached the maximum per page
    if (countOfCurrentPage === countPerPage) {
      //Start adding to the next page (in next iteration)
      page++;

      //reset the count back to 0 (fresh for the new page)
      countOfCurrentPage = 0;
    }
  });

  //return the payload!
  return payload;
}
//Example return: [1,1,1,2,2,2,3,3,3] (9 members, 3 per page)



// WEBPACK FOOTER //
// ./src/helpers/get-pages-from-array.js